import * as React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { get } from 'lodash';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import Timer, { Minutes, Seconds } from 'components/Timer/Timer';
import { TickIcon } from 'components/Icons/Icons';
import { pollUPIStatusAction } from 'actions/PaymentActions/PaymentActions';
import styles from './UPIStatusPoll.css';
// with the last upi poll call we should wait for some time.
const FINAL_UPI_POLL_WAIT_TIME = 800;
export var UPIPollStatusTypes;
(function (UPIPollStatusTypes) {
    UPIPollStatusTypes["PENDING"] = "PENDING";
    UPIPollStatusTypes["FAILED"] = "FAILED";
    UPIPollStatusTypes["SUCCESS"] = "SUCCESS";
})(UPIPollStatusTypes || (UPIPollStatusTypes = {}));
export class UPIStatusPoll extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            shouldScheduleUPIPoll: true,
            pollRequestTimeoutId: 0
        };
        this.onTimerExpiry = () => {
            // lets wait for a buffer time before expiring the poll time
            // this is done to wait for response from last poll request if any
            setTimeout(() => {
                const { onUPIPollTimerExpiry } = this.props;
                this.stopUPIPolling();
                onUPIPollTimerExpiry && onUPIPollTimerExpiry();
            }, FINAL_UPI_POLL_WAIT_TIME);
        };
        this.setupUPIPolling = () => {
            const { token, transactionId, pollingInfo, pollUPIStatus } = this.props;
            const { shouldScheduleUPIPoll } = this.state;
            if (shouldScheduleUPIPoll && pollingInfo) {
                const pollRequestTimeoutId = window.setTimeout(() => {
                    pollUPIStatus && pollUPIStatus(token, transactionId);
                    this.setState({ shouldScheduleUPIPoll: true });
                }, pollingInfo.polling_interval);
                this.setState({
                    shouldScheduleUPIPoll: false,
                    pollRequestTimeoutId
                });
            }
        };
        this.stopUPIPolling = () => {
            clearTimeout(this.state.pollRequestTimeoutId);
            this.setState({ shouldScheduleUPIPoll: false });
        };
        this.handleGoBack = () => {
            const { upiPollState: paymentData, onUPIPaymentCancel } = this.props;
            this.stopUPIPolling();
            onUPIPaymentCancel(paymentData);
        };
    }
    componentDidMount() {
        const { token, transactionId, pollUPIStatus } = this.props;
        pollUPIStatus(token, transactionId);
        this.setupUPIPolling();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { onUPIPaymentSuccess } = this.props;
        const paymentData = get(nextProps, 'upiPollState');
        const responseStatus = get(paymentData, 'response_status');
        if (responseStatus === UPIPollStatusTypes.PENDING) {
            this.setupUPIPolling();
        }
        else if (responseStatus === UPIPollStatusTypes.SUCCESS && onUPIPaymentSuccess) {
            this.stopUPIPolling();
            onUPIPaymentSuccess(paymentData);
        }
    }
    componentWillUnmount() {
        this.stopUPIPolling();
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.pollingInfo !== this.props.pollingInfo;
    }
    render() {
        const { token, transactionId, upiId, pollingInfo } = this.props;
        if (!token || !transactionId || !pollingInfo) {
            return null;
        }
        return (<div className={styles['upi-poll']}>
				<div className={styles['payment-account']}>
					{stringTemplate('upiPaymentAccount')}
					<span className={styles['account']}>{upiId}</span>
					{TickIcon({ width: 14, height: 14, fill: '#fff', className: styles['green-tick'] })}
				</div>

				<div className={styles['payment-timer']}>
					{stringTemplate('completePaymentTimer')}
					<span className={styles['timer']}>
						<Timer timeRemaining={pollingInfo.timeout} onExpiry={this.onTimerExpiry}>
							<Minutes padZeros suffix=":"/>
							<Seconds padZeros/>
						</Timer>
					</span>
				</div>

				<StringWidget strKey="upiPaymentNote" className={styles['subtitle']}/>

				<div className={styles['steps']}>
					<img src={pollingInfo.image_url} width={47} height={182}/>

					<div className={styles['steps-text']}>
						<StringWidget strKey="upiPaymentStepOne" className={styles['step-one']}/>
						<StringWidget strKey="upiPaymentStepTwo" className={styles['step-two']}/>
					</div>
				</div>

				<div className={cx(styles['link'], styles['return-link'])} onClick={this.handleGoBack}>
					{stringTemplate('goBackBtn')}
				</div>
			</div>);
    }
}
const mapStateToProps = state => ({
    upiPollState: state.payments.upiPollState
});
const mapDispatchToProps = {
    pollUPIStatus: pollUPIStatusAction
};
export default connect(mapStateToProps, mapDispatchToProps)(UPIStatusPoll);
